const { WEBSITE_URL } = process.env;
const IMAGE_URL = `${WEBSITE_URL}/images/v2`;

const IS_DEV_MODE = process.env.NODE_ENV === 'development';
const IS_CLIENT_MODE = typeof window !== "undefined";


let SONGBIRD_URL = process.env.SONGBIRD_URL;

// AWS WAF CAPTCHA integration (replaces Google reCAPTCHA).
const AWS_WAF_CAPTCHA_API_KEY = process.env.AWS_WAF_CAPTCHA_API_KEY;
const AWS_WAF_CAPTCHA_JSAPI_URL = process.env.AWS_WAF_CAPTCHA_JSAPI_URL;

export {
  WEBSITE_URL,
  IMAGE_URL,
  IS_DEV_MODE,
  IS_CLIENT_MODE,
  SONGBIRD_URL,
  AWS_WAF_CAPTCHA_API_KEY,
  AWS_WAF_CAPTCHA_JSAPI_URL,
};
